<template lang="pug">
  .simple-select-form
    .simple-select-form__button(
    tabindex="0"
    @click="onClickSelect($event)"
    :class="{ 'simple-select-form__button__default': enableDefaultValueClass && defaultValue.value === null  }"
    ) {{ defaultValue.text ? defaultValue.text : defaultValue }}
    custom-select-list(
    v-if="showList && !readOnly"
    :show-list="showList"
    :list-data="_listData"
    :dataList="listData"
    :default-value="_defaultValue"
    @close="closeSelectList"
    @onSelectItem="selectItem"
    )
</template>

<script>
import customSelectList from "./components/custom-select-list.vue";

export default {
  name: "custom-select",
  components: {
    customSelectList,
  },
  props: {
    listData: {
      type: [Object, Array],
      default: () => {},
    },
    defaultValue: {
      type: [Object, String],
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    enableDefaultValueClass: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showList: false,
    };
  },
  methods: {
    selectItem(item) {
      this._defaultValue = item;
    },
    closeSelectList() {
      this.showList = false;
    },
    toggleSelectList() {
      this.showList = !this.showList;
    },
    onClickSelect(e, type) {
      if (this.showList) {
        this.toggleSelectList();
        return;
      }
      const _e = e;
      if (!type) {
        setTimeout(() => {
          this.onClickSelect(_e, "second");
        }, 0);
      } else {
        e.preventDefault();
        e.stopPropagation();
        this.toggleSelectList();
      }
    },
  },
  computed: {
    _listData: {
      cache: false,
      get() {
        return this.listData;
      },
    },
    _defaultValue: {
      cache: false,
      get() {
        return this.defaultValue;
      },
      set(value) {
        this.$emit("on-change-default-value", value, this.type);
      },
    },
  },
};
</script>
